import { RankedTester, and, or, rankWith, optionIs, schemaTypeIs } from "@jsonforms/core";

export const SelectQueyTester: RankedTester = rankWith(
  5,
  and(or(schemaTypeIs("number"), schemaTypeIs("integer")), optionIs("selectIdQuery", true))
);

export default SelectQueyTester;
